// extracted by mini-css-extract-plugin
export var square = "Square-module--square--1-5CG";
export var fadeIn = "Square-module--fadeIn--59d3K";